// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardOption\ApiTopicCardOption.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';

// TopicCardOptionData is the class that TopicCardOption serializes to/from
export interface TopicCardOptionData {
    Id : number;
	
    Card : TopicCardData | null;
    CardId : number;
	
    DisplayOrder : number;
    Guid : /* GUID */ string;
    Text : string;
}

// TopicCardOptionOptions is the class which may be passed to the TopicCardOption constructor to define optional initial data values
export interface TopicCardOptionOptions {
    Id : number;
	
    Card? : TopicCardOptions | null;
    CardId? : number;
	
    DisplayOrder? : number;
    Guid? : /* GUID */ string;
    Text? : string;
}

export class TopicCardOption {
    public Id : DataSignal<number>;
	
    public Card : DataSignal<TopicCard | null>;
    public CardId : DataSignal<number>;
	
    public DisplayOrder : DataSignal<number>;
    public Guid : DataSignal<string>;
    public Text : DataSignal<string>;

    constructor();
    constructor(data : TopicCardOptionOptions);
    constructor(data: TopicCardOptionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Card = S.value<TopicCard | null>(null);
        this.CardId = jsonableObservable(S.value<number>(data && data.CardId !== undefined ? data.CardId : 0));
	    
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Text = jsonableObservable(S.value<string>(data && data.Text !== undefined ? data.Text : ''));
    }

    static key(obj : TopicCardOption) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardOptionOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardOption, data : TopicCardOptionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CardId !== undefined) obj.CardId(data.CardId);
	        
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Text !== undefined) obj.Text(data.Text);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardOption.ts